import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowfall = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.3463 4.13931C14.5455 4.33054 14.5519 4.64706 14.3607 4.84627L11.0007 8.34627C10.9064 8.44448 10.7761 8.5 10.64 8.5C10.5039 8.5 10.3736 8.44448 10.2793 8.34627L8.24 6.22199L5.82335 8.73933L7.54513 10.3922L2 12L3.38019 6.3939L5.10197 8.0468L7.87931 5.15373C7.97359 5.05552 8.10385 5 8.24 5C8.37615 5 8.50641 5.05552 8.60069 5.15373L10.64 7.27801L13.6393 4.15373C13.8305 3.95453 14.1471 3.94807 14.3463 4.13931Z",
		fill: "#EF4444"
	})
});
export default SvgArrowfall;
